<template>
  <div class='chart_container'>
    <dashboard-control-points-pie-chart :chart-data="datacollection" :options="options"/>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import DashboardControlPointsPieChart from './DashboardControlPointsPieChart';

export default {
  name: 'DashboardControlPointsPieChartContainer',
  components: {
    DashboardControlPointsPieChart,
  },
  props: {
    data: {
      required: true,
      type: Object,
      default: () => ({
        waiting_for_approval: 0,
        in_progress: 0,
        in_closure_process: 0,
        completed: 0,
      })
    },
    name: {
      type: String,
      default: () => '',
    },
    colors: {
      type: Array,
      default: () => (['#ca2727', '#FCAF17', '#17479E', '#35AB46']),
    }
  },
  data() {
    return {
      labels: ['На рассмотрении', 'Выполняются', 'В процессе закрытия', 'Выполнены'],
    }
  },
  computed: {
    ...mapState('dashboard', ['control_points_stats']),
    options() {
      return {
        title: {
          text: this.$props.name,
          display: !!this.$props.name,
        },
        legend: {
          display: false,
        },
        labels: {
          fontSize: '22px'
        }
      }
    },
    datasets() {
      let datasets = [{
        label: this.$props.name,
        backgroundColor: this.$props.colors,
      }];
      datasets[0].data = [
        this.$props.data.waiting_for_approval,
        this.$props.data.in_progress,
        this.$props.data.in_closure_process,
        this.$props.data.completed,
      ];
      return datasets;
    },
    datacollection() {
      return {
        labels: this.labels,
        datasets: this.datasets,
      }
    }
  },
}
</script>

<style lang="scss" scoped>
.chart_container {
  max-width: 200px;
}
</style>
